"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 */
exports.switchShadowEdit = function (core, isOn) {
    var lifecycle = core.lifecycle, contentDiv = core.contentDiv;
    var shadowEditFragment = lifecycle.shadowEditFragment, shadowEditSelectionPath = lifecycle.shadowEditSelectionPath;
    var wasInShadowEdit = !!shadowEditFragment;
    if (isOn) {
        if (!wasInShadowEdit) {
            var range = core.api.getSelectionRange(core, true /*tryGetFromCache*/);
            shadowEditSelectionPath = range && roosterjs_editor_dom_1.getSelectionPath(contentDiv, range);
            shadowEditFragment = core.contentDiv.ownerDocument.createDocumentFragment();
            roosterjs_editor_dom_1.moveChildNodes(shadowEditFragment, contentDiv);
            shadowEditFragment.normalize();
            core.api.triggerEvent(core, {
                eventType: 17 /* EnteredShadowEdit */,
                fragment: shadowEditFragment,
                selectionPath: shadowEditSelectionPath,
            }, false /*broadcast*/);
            lifecycle.shadowEditFragment = shadowEditFragment;
            lifecycle.shadowEditSelectionPath = shadowEditSelectionPath;
        }
        roosterjs_editor_dom_1.moveChildNodes(contentDiv);
        contentDiv.appendChild(lifecycle.shadowEditFragment.cloneNode(true /*deep*/));
    }
    else {
        lifecycle.shadowEditFragment = null;
        lifecycle.shadowEditSelectionPath = null;
        if (wasInShadowEdit) {
            core.api.triggerEvent(core, {
                eventType: 18 /* LeavingShadowEdit */,
            }, false /*broadcast*/);
            roosterjs_editor_dom_1.moveChildNodes(contentDiv);
            contentDiv.appendChild(shadowEditFragment);
            core.api.focus(core);
            if (shadowEditSelectionPath) {
                core.api.selectRange(core, roosterjs_editor_dom_1.createRange(contentDiv, shadowEditSelectionPath.start, shadowEditSelectionPath.end));
            }
        }
    }
};
//# sourceMappingURL=switchShadowEdit.js.map